
window.addEventListener('load', function() {
    var $ = theme.jQuery;

    $('.product-area__thumbs .product-area__thumbs__thumb').on('mouseenter', function() {
        const media_id = $(this).attr('data-media-thumb-id');
        $('.product-slider .theme-img').removeClass('current-desktop-image');
        $('.product-slider [data-media-id="'+ media_id +'"]').parent().addClass('current-desktop-image');

        $('.product-area__thumbs .product-area__thumbs__thumb').removeClass('current-thumb');
        $(this).addClass('current-thumb');
    });
    
    
    $('.product-area__thumbs .product-area__thumbs__thumb a').on('click', function(e) {
        e.preventDefault();

        const media_id = $(this).parent().attr('data-media-thumb-id');
        $('.product-slider .theme-img').removeClass('current-desktop-image');
        $('.product-slider [data-media-id="'+ media_id +'"]').parent().addClass('current-desktop-image');

        $('.product-area__thumbs .product-area__thumbs__thumb').removeClass('current-thumb');
        $(this).parent().addClass('current-thumb');
    });


    $('#go_to_video_btn').on('click', function(e) {
        e.preventDefault();
        const media_id = $('.video_product').children(':first').attr('data-media-id');
        $('.product-slider .theme-img').removeClass('current-desktop-image');
        $('.product-slider [data-media-id="'+ media_id +'"]').parent().addClass('current-desktop-image');

        $('.product-area__thumbs .product-area__thumbs__thumb').removeClass('current-thumb');
        $(this).parent().addClass('current-thumb');
    });
})
